import { useContext } from "react";

import { AuthContext } from "../context/AuthContext";

export const useAuth = () => {
  return useContext(AuthContext);
};
// export const getOrgId = () => {
//   const cookies = document.cookie.split(";");

//   const orgCookie = cookies.find((cookie) =>
//     cookie.trim().startsWith("orgId=")
//   );

//   return orgCookie
//     ? decodeURIComponent(orgCookie.split("=")[1])
//     : null;
// };
export const getOrgId=()=>{
  const orgId=JSON.parse(localStorage.getItem("patientPersona"));
  console.log(orgId,"in the global orgId");
  return orgId?.orgId;
}